export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_multiflow.png",
      alt: "Nome da extensão",
    },
    title: "MultiFlow Trading",
    text: [
      "A MultiFlow nasceu da visão de um desenvolvedor com mais de 7 anos de atuação no mercado, trazendo estratégias automatizadas para os mais variados ativos do mercado (índice, dólar, cripto entre outros). \n\nPriorizamos o que realmente importa: execução eficiente, gestão rigorosa de risco e, acima de tudo, uma curva de ganhos suave e consistente trazendo resultados reais e sustentáveis para nossos parceiros e clientes.",
    ],
    testimonial: {
      text: "A MultiFlow integra os elementos cruciais para o sucesso na alavancagem inteligente de capital no mercado.",
      author: {
        name: "Luís H. M. Ferreira – Estrategista Chefe",
        // picture: "https://i.pravatar.cc/150?img=70",
      },
    },
  },
  stats: {
    title: "Alguns dados da Multiflow",
    subtitle: "Mais de 7 Anos de Desenvolvimento",
    data: [
      {
        value: "+100",
        description: "Algoritmos criados",
      },
      {
        value: "2",
        description: "Portifólios ativos",
      },
      {
        value: "9",
        description: "Robôs em execução real",
      },
    ],
  },
  features: {
    title: "Por que utilizar os robôs da MultiFlow?",
    subtitle: "Veja quais as principais vantagens dos robôs da MultiFlow.",
    data: [
      {
        title: "100 % Automatizado",
        description:
          "Sabemos que tempo é dinheiro e qualidade de vida, por isso todos nossos parâmetros de análise e gestão de risco são automáticos e acompanhados por nossa equipe para que você tenha tempo livre para outras atividades.",
      },
      {
        title: "Especialista em Portifólios",
        description:
          "Nosso foco além de trazer as melhores estratégias está também em disponibilizar a melhor combinação entre elas no modo (portifólio), onde buscamos através de vários testes as melhores correlações, balanceamento de risco e gestão de lotes.",
      },
      {
        title: "Período de avaliação de 7 dias.",
        description:
          "Caso não atenda às suas expectativas nos primeiros 7 dias de uso, reembolsamos integralmente seu valor pago pelo plano.",
      },
      {
        title: "Suporte Exclusivo",
        description:
          "Ficou alguma dúvida, seja antes da contratação ou durante o uso das nossas estratégias? É só entrar em contato pelo whatsapp que teremos o prazer de lhe auxiliar.",
      },
      {
        title: "Segurança e agilidade",
        description:
          "Os nossos algoritmos estão hospedados em máquina virtual com localização estrategicamente pensada para garantir maior agilidade na execução das ordens além de segurança contra possíveis quedas de conexão ou desligamento.",
      },
      {
        title: "Sem medo, sem ganância, só execução.",
        description: "Enquanto o psicológico sabota o Trader humano, robôs fazem exatamente o que foi programado.",
      },
    ],
  },
  cta: {
    title: "Pronto para iniciar?",
    subtitle: "Melhore sua performance agora mesmo.",
  },
  about: {
    title: "Sobre nós",
    subtitle: "A MultiFlow",
    col1: [
      "A MultiFlow surgiu da experiência de seu desenvolvedor e Trader, Luis Henrique Machado Ferreira, com mais de 7 anos no mercado, dedicado ao trading e análise gráfica. Após estudar diversos métodos e testar inúmeras estratégias, ele identificou práticas eficazes para resultados seguros sem deixar de lado a busca pelo aprimoramento constante dos seus conhecimentos. ",
      "Priorizamos execução eficiente, controle rigoroso de riscos e ganhos estáveis, assegurando resultados concretos e sustentáveis para parceiros e clientes que buscam potencializar seus ganhos. Sabemos que o trading não é um ponto de chegada por isso estamos constantemente monitorando nossas estratégias para acompanhar e se adaptar as possíveis mudanças de mercado.",
    ],
  },
  plans: {
    title: "Planos",
    subtitle: "Conheça os planos da MultiFlow",
  },
  strategies: {
    title: "Nossos Algoritmos",
    heading: "Estratégias Testadas e Validadas em atividade.",
    subtitle: "Escolha nossas estratégias e comece a lucrar com o melhor do trading automatizado agora mesmo.",
  },
};
